const isRemote = true; // cambiar a true en producción

export const API_URL = isRemote
  ? "https://rehaday.eodyne.com/rehaday-server/api"
  : "http://localhost:5000/api";

export const primaryColor    = "#1A73E8";
export const primaryDark     = "#1557B0";
export const secondaryColor  = "#34A853";
export const errorColor      = "#D93025";
export const bgColor         = "#F1F3F4";
export const sidebarWidth    = 240;
